import Cookies from 'js-cookie'

export const GTAG = process.env.NEXT_PUBLIC_GTM || ''

export const GAClientId = process.env.NEXT_PUBLIC_GA4 || ''

export function getGA4SessionId(): string | undefined {
  const cookieSuffix = GAClientId.replace('G-', '')

  const regex = /(?<=s)(.*?)(?=\$)/g

  return Cookies.get(`_ga_${cookieSuffix}`)?.match(regex)?.[0]
}

export function getGAClientId(): string | undefined {
  const cookieArr = Cookies.get('_ga')?.split('.')?.reverse()

  if (!cookieArr || cookieArr.length < 2) return undefined

  return `${cookieArr[1]}.${cookieArr[0]}`
}
